<template>
  <div id="make-payment" class="container-24">
    <loading
      :show="showSpinner"
      label="Loading..."
      :overlay="true">
    </loading>

    <div class="container mk-payment-container">
      <div class="row mk-payment-section">
        <section class="col-sm-12 mk-payment-desc-header">
          <h3 class="title-24">Make a Payment</h3>
          <section class="card-24">
            <div class="card-text-container col-sm-14">
              <div class="text-24">
                <p>
                  Our records indicate that the following invoices are open.
                </p>
              </div>
            </div>
          </section>
        </section><!-- mk-payment description -->
      </div>
    </div>

    <div class="container mk-payment-container">
      <div class="row mk-payment-section">
        <div class="col-md-12">
          <div class="row edit-form">
            <div class="col-lg-10 col-md-10 col-sm-10 mk-payment-about">
              <div class="row">
                <div class="mk-payment-about-section materialized col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                  <div class="form-group materialized">
                    <multi-select v-model="mkPaymentData.memberFaoNames" :options="allMembers" :multiple="true" :searchable="false"
                                  :disabled="allMembers.length < 2" :allowEmpty="false" :closeOnSelect="false"
                                  label="memberFullName" id="mk-payment-members" @remove="(searchQuery, id) => filterMember(searchQuery, id)" @select="filteredMember = ''"
                                  placeholder="Select" track-by="memberNumber" :limit="0" :limit-text="limitText">
                    </multi-select>
                    <label for="mk-payment-members">Select Members</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mk-payment-container">
      <invoices-table :agreementData="agreementData" :showSpinner="showSpinner" :filteredMember="filteredMember" v-on:change="value => {selectedAgreements = value}" ref="invoicesTable" ></invoices-table>

      <div class="table-footer clearfix mk-payment-table-footer">
        <div class="pull-right"><span class="tfoot-text">Amount to Pay: ${{ invoiceTotal }}</span></div>
      </div>
      <div class="primary-member-legend"><i class="fa fa-star"></i> Primary Member</div>
        <credit-card :value="creditCardData" @input="nValue => setCreditCardData(nValue)" :disabled="false" :togglable="false"></credit-card>
        <p></p>
        <div class="actions">
          <div class="row bottom-cta-button">
            <div class="col-xs-12 materialized pm-confirm-button">
              <button class="btn btn-primary pull-right"
                v-on:click="payInvoices()"
                      :disabled="isPaying || selectedAgreements.length === 0 || !isCCDataSet || errors.any('paymentMethodCC')">
                <i class="fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"
                  v-show="isPaying"></i>Pay Now</button>
            </div>
          </div>
        </div>
      </div>

    <update-agreements-modal v-if="showModalUAgreements"
                              @close="showPaymentConfirmation(false)"
                              @agreeUpdate="value => { handleAgree(value) }"
                              :agreementsEFTData="agreementsEftData"
                              :paymentInfo="getBankInformation()"></update-agreements-modal>

    <update-agreements-tac-modal v-if="showModalUAgreementsTAC"
                                  @cancel="showPaymentConfirmation(false)"
                                  @close="showPaymentConfirmation(true)"
                                  :paymentData="buildPaymentData()"
                                  :htmlTac="htmlTac"></update-agreements-tac-modal>

  </div>
</template>

<script>
  import _ from 'lodash'
  import InvoicesTable from './openInvoicesTable.vue'
  import { ServiceContainer, dateRange, loading } from 'CommonBilling'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import { CreditCard } from 'my-account-payment'
  import UpdateAgreementsModal from './update_agreements_eft/UpdateAgreementsModal.vue'
  import UpdateAgreementsTACModal from './update_agreements_eft/UpdateAgreementsTACModal.vue'
  const payInvoicesService = ServiceContainer.payInvoicesService
  const paymentUpdateService = ServiceContainer.paymentUpdateService

  export default {
    name: 'make-payment',
    components: {
      'date-range': dateRange,
      'loading': loading,
      'multi-select': Multiselect,
      'invoices-table': InvoicesTable,
      'credit-card': CreditCard,
      'update-agreements-modal': UpdateAgreementsModal,
      'update-agreements-tac-modal': UpdateAgreementsTACModal
    },
    data () {
      return {
        showSpinner: false,
        agreementData: {},
        agreementsEftData: {},
        selectedAgreements: [],
        selectedEftAgreements: [],
        filteredMember: '',
        memberNumber: '',
        memberName: '',
        htmlTac: '',
        isPaying: false,
        rows: [],
        hasInvoiceTableLoadedData: false,
        interval: '',
        mkPaymentData: {
          memberFaoNames: [],
          memberFaos: [],
          rowsPerPageText: 'Rows:',
          nextText: '',
          prevText: ''
        },
        creditCardData: {
          nameOnCard: '',
          cardNumber: '',
          expirationMonth: '01',
          expirationYear: 2017,
          cardType: '',
          validationErrors: []
        },
        showModalUAgreements: false,
        showModalUAgreementsTAC: false
      }
    },
    mounted () {
      paymentUpdateService.getTacHtml({}).then((response) => {
        this.htmlTac = response.data
      })
      this.showSpinner = true
      this.populateTable()
    },
    methods: {
      populateTable () {
        this.callSearchOpenInvoices(true).then((response) => {
          this.showSpinner = false
          this.isPaying = false
          this.selectedAgreements = []
          this.setData(response.data)
          this.mkPaymentData.memberFaoNames = this.mkPaymentData.memberFaos.concat({
            'memberFullName': this.memberName,
            'memberNumber': this.memberNumber
          })
          this.hasInvoiceTableLoadedData = true
        }).catch((error) => {
          this.showSpinner = false
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            this.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
              position: 'bottom-center',
              duration: 10000
            })
          }
        })
      },
      filterMember (removedMember, id) {
        this.filteredMember = removedMember.memberNumber
      },
      limitText (count) {
        if (count === 1) {
          let start = this.mkPaymentData.memberFaoNames[0].memberNumber === this.memberNumber ? '★ ' : ''
          start += this.mkPaymentData.memberFaoNames[0].memberFullName
          return start
        }
        return 'Selected (' + count + ')'
      },
      callSearchOpenInvoices (withCache) {
        return payInvoicesService.getOpenInvoices({
          ttl: 10,
          params: {
            pastDueInvoices: false
          }
        })
      },
      /**
       * Sets the information for view make a payment from the <openInvoicesService>
       * @param {Object} viewData
       * @return {Null}
       */
      setData (viewData) {
        this.rows = this.setIdReferential(viewData.invoices)
        this.mkPaymentData.memberFaos = viewData.faos
        this.memberNumber = viewData.memberNumber
        this.memberName = viewData.memberName
        this.agreementData = {
          rows: this.rows,
          mkPaymentData: this.mkPaymentData,
          memberData: { number: this.memberNumber, name: this.memberName }
        }
      },
      setIdReferential (data) {
        data.forEach((invoice, index) => {
          invoice.idReferential = 'inv-' + index
        })
        return (data)
      },
      setCreditCardData (data) {
        this.creditCardData = data
      },
      payInvoices () {
        this.$validator.validateAll('paymentMethodCC').then((result) => {
          if (result) {
            this.payInvoicess()
          }
        })
      },
      payInvoicess () {
        this.isPaying = true
        return payInvoicesService.payInvoices({
          invoicePayments: this.selectedInvoices,
          bankInformationDTO: {
            accountNumber: this.creditCardData.cardNumber,
            accountType: this.creditCardData.cardType,
            creditCardExpireDate: this.creditCardData.expirationMonth + '-' + this.creditCardData.expirationYear,
            nameOnAccount: this.creditCardData.nameOnCard
          }
        }).then((success) => {
          // Show Success stuff
          this.handleSuccessPayment()
        }).catch((error) => {
          // Show Error message
          let errorMsg = ''
          if (error.response !== undefined && error.response.data !== undefined) {
            errorMsg = error.response.data.errorMessage
          } else {
            errorMsg = 'There was an error when trying to make a payment'
          }

          this.$toasted.show(errorMsg,
            {
              theme: 'primary',
              position: 'bottom-center',
              duration: 10000
            },
            function () {})

          this.isPaying = false
        })
      },
      handleSuccessPayment () {
        if (this.$route.query.callAutoPay !== undefined) {
          this.showPaymentConfirmation(false)
        } else {
          this.getAgreementsEft()
            .then((response) => {
              if (response && response.agreementEFTs.length) {
                this.showModalUAgreements = true
              } else {
                this.showPaymentConfirmation(false)
              }
            })
            .catch((err) => {
              err()
            })
        }
      },
      showPaymentConfirmation (updatedEftAgreements) {
        let paymentData = {
          bankInformation: this.getBankInformation(),
          agreements: this.getSelectedAgreementsObject(),
          eftAgreements: updatedEftAgreements ? this.agreementsEftData : [],
          selectedEftAgreements: updatedEftAgreements ? this.selectedEftAgreements : []
        }
        this.showModalUAgreements = false
        this.goToPaymentConfirmation(paymentData)
      },
      getSelectedAgreementsObject () {
        return _.filter(this.agreementData.rows, (due) => _.includes(this.selectedAgreements, due.idReferential))
      },
      goToPaymentConfirmation (paymentData) {
        let confirmParams = {
          paymentData: paymentData,
          confirmTitle: 'Payment Confirmation',
          confirmDescription: 'Make a Payment',
          previousView: 'makeAPayment'
        }
        this.$router.push({name: 'MakePaymentConfirmation', params: confirmParams})
      },
      getAgreementsEft () {
        this.showSpinner = true
        let responsePromise = new Promise((resolve, reject) => {
          paymentUpdateService.getPaymentEftAgreements({useCache: false}).then((response) => {
            this.agreementsEftData = response.data
            resolve(this.agreementsEftData)
          }).catch((error) => {
            
          }).finally((notif) => {
            this.showSpinner = false
            resolve(false)
          })
        })
        return responsePromise
      },
      handleAgree (val) {
        this.selectedEftAgreements = val
        this.showModalUAgreements = false
        this.showModalUAgreementsTAC = true
      },
      buildPaymentData () {
        return {
          'agreementNumbers': this.selectedEftAgreements,
          'bankInformationDTO': {
            'accountNumber': this.creditCardData.cardNumber,
            'accountType': this.creditCardData.cardType,
            'creditCardExpireDate': this.creditCardData.expirationMonth + '-' + this.creditCardData.expirationYear,
            'nameOnAccount': this.creditCardData.nameOnCard
          }
        }
      },
      getBankInformation () {
        return {
          cardNumber: this.creditCardData.cardNumber.substr(-4),
          cardExpirationDate: this.creditCardData.expirationMonth + '/' + this.creditCardData.expirationYear.toString().substr(-2),
          cardType: this.creditCardData.cardType
        }
      }
    },
    computed: {
      selectedInvoices: {
        get: function () {
          let invoices = []
          let invoiceData = {}
          const data = this.getSelectedAgreementsObject()
          _.map(data, (invoice) => {
            invoiceData = {
              referenceNumber: invoice.referenceNumber,
              dueDate: invoice.date
            }
            invoices.push(invoiceData)
          })
          return (invoices)
        }
      },
      allMembers: {
        get: function () {
          const selectableMembers = this.mkPaymentData.memberFaos.slice(0)
          return selectableMembers.concat({memberNumber: this.memberNumber, memberFullName: this.memberName})
        }
      },
      invoiceTotal: {
        get: function () {
          let total = 0
          const data = this.getSelectedAgreementsObject()
          _.map(data, (invoice) => {
            total += invoice.balance
          })
          return total.toFixed(2)
        }
      },
      isCCDataSet: {
        get: function () {
          return (this.creditCardData.nameOnCard.length > 0 && this.creditCardData.cardNumber.length > 0)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  // ADA multiselect fix
  ul.multiselect__content {
    li.multiselect__element {
      .multiselect__option--highlight {
        background: $md-brand-green;
        &::after {
          background: $md-brand-green;
        }
      }
      .multiselect__option--selected {
        &.multiselect__option--highlight {
          background: $md-brand-red;
          &::after {
            background: $md-brand-red;
          }
        }
      }
    }
  }
  i.fa.fa-star {
    font-size: .75em;
    vertical-align: super;
    top: 4px;
    position: relative;
  }

  .mk-payment-desc-header {
    font-family: "ApexMedium", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
    font-size: 18px;
    margin-top: 0px;
    .card-24 {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px;
    }
  }

  #make-payment .cc-logo-container {
    float: inherit;
  }

  .form-group.materialized .multiselect.multiselect--active {
    z-index: 7;
  }
  .materialized .good-table .table-footer.clearfix {
    margin-bottom: 0px;
    div.pull-right span.tfoot-text {
      font-weight: bold;
    }
  }
  .mk-payment-table-footer {
    background-color: #44697D;
    color: #ffffff;
    padding: 15px 20px;
    border-radius: 0;
    border: 0;
    font-weight: bold;
  }
  .primary-member-legend {
    color: #9a9a9a;
    padding: 15px 0 15px 15px;
    border-bottom: 1px solid #dddddd;
  }
  .payment-done-color {
    color: $md-checkbox-checked-color;
  }
  .mk-payment-container .edit-form {
    padding: 10px 15px;
    background-color: #f5f5f5;
    margin: 0;
  }
  .pm-confirm-button {
    margin-bottom: 50px
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) { }

  /* Small devices (tablets, 768px and up) */
  @media (min-width: $screen-sm-min) { }

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: $screen-md-min) { }

  /* Large devices (large desktops, 1200px and up) */
  @media (min-width: $screen-lg-min) { }

  @media only screen and (max-width: 600px) { }

  @media only screen and (max-width: 750px) { }
</style>



// WEBPACK FOOTER //
// node_modules/MakeAPayment/MakeAPayment.vue